import React from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Button,
  Spinner,
  Input,
} from "reactstrap";

const DeviceTab = ({
  campaign,
  devicesLoading,
  filteredDevices,
  selectedDevices,
  deviceSearch,
  setDeviceSearch,
  toggleDeviceSelection,
  handleAssignDevices,
  handleUnassignDevices,
  assigningDevices,
  unassigningDevices,
  getDeviceImageUrl,
}) => {
  return (
    <>
      {/* <div className="d-flex justify-content-between align-items-center mb-3"> */}
      {/* <div className="d-flex align-items-center gap-3">
          <Input
            placeholder="Search by MAC ID or Campaign name..."
            value={deviceSearch}
            onChange={(e) => setDeviceSearch(e.target.value)}
            style={{ maxWidth: 300 }}
          />
          <Badge
            color="secondary"
            pill
            style={{ fontSize: "12px", padding: "6px 12px" }}
          >
            {filteredDevices?.length || 0} of{" "}
            {deviceSearch
              ? filteredDevices?.length || 0
              : filteredDevices?.length || 0}{" "}
            devices
          </Badge>
        </div> */}

      {/* {selectedDevices.length > 0 && (
          <div className="d-flex gap-2">
            <Button
              size="sm"
              color="success"
              onClick={handleAssignDevices}
              disabled={assigningDevices}
            >
              {assigningDevices ? (
                <>
                  <Spinner size="sm" className="me-2" /> Assigning...
                </>
              ) : (
                `Assign (${selectedDevices.length})`
              )}
            </Button>

            <Button
              size="sm"
              color="danger"
              onClick={handleUnassignDevices}
              disabled={unassigningDevices}
            >
              {unassigningDevices ? (
                <>
                  <Spinner size="sm" className="me-2" /> Unassigning...
                </>
              ) : (
                `Unassign (${selectedDevices.length})`
              )}
            </Button>
          </div>
        )} */}
      {/* </div> */}

      {devicesLoading ? (
        <div className="text-center py-5">
          <Spinner />
          <p className="text-muted mt-2">Loading devices...</p>
        </div>
      ) : filteredDevices && filteredDevices.length > 0 ? (
        <Row className="g-3">
          {filteredDevices.map((device) => {
            const isSelected = selectedDevices.some(
              (d) => d.macId === device.macId,
            );

            return (
              <Col key={device.macId} xs="12" sm="6" md="4" lg="2">
                <Card
                  onClick={() => toggleDeviceSelection(device)}
                  className={`device-card border ${
                    isSelected ? "border-primary shadow" : "border-light"
                  }`}
                  style={{
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    backgroundColor: isSelected
                      ? "rgba(0, 123, 255, 0.05)"
                      : "#fff",
                  }}
                >
                  <div
                    style={{
                      height: 120,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#f8f9fa",
                      borderBottom: "1px solid #e9ecef",
                      position: "relative",
                    }}
                  >
                    <img
                      src={getDeviceImageUrl()}
                      alt={device.campaignName}
                      style={{
                        height: "100%",
                        maxWidth: "90%",
                        objectFit: "contain",
                      }}
                    />
                    {isSelected && (
                      <Badge
                        color="primary"
                        pill
                        className="position-absolute top-0 end-0 m-2"
                      >
                        <i className="ri-check-line me-1" />
                        Selected
                      </Badge>
                    )}
                  </div>

                  <CardBody className="p-3">
                    <h6
                      className="mb-2 text-truncate"
                      style={{ fontSize: "14px", fontWeight: 600 }}
                    >
                      {device.deviceName || "Unnamed Device"}
                    </h6>

                    <div
                      className="mb-2 text-muted"
                      style={{ fontSize: "12px" }}
                    >
                      <p>{device.organizationName}</p>
                      <strong>MAC ID:</strong>
                      <div
                        className="text-break"
                        style={{ fontSize: "11px", fontFamily: "monospace" }}
                      >
                        {device.macId}
                      </div>
                    </div>

                    {/* {device.assignedCount !== undefined && (
                      <div className="d-flex justify-content-between align-items-center">
                        <small className="text-muted">Assigned:</small>
                        <Badge color="info" pill>
                          {device.assignedCount}
                        </Badge>
                      </div>
                    )} */}
                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>
      ) : (
        <div className="text-center py-5 text-muted">
          <i
            className="ri-inbox-2-line"
            style={{ fontSize: "40px", opacity: 0.3 }}
          />
          <p className="mt-2">No devices found</p>
        </div>
      )}
    </>
  );
};

export default DeviceTab;
